import confetti from "canvas-confetti";

/** Small, on-brand blue burst for the desktop CTA success states (Mac link
 *  sent / Windows waitlist joined). Deliberately modest: a nod, not a party. */
export function fireBlueConfetti() {
  try {
    confetti({
      particleCount: 45,
      spread: 60,
      startVelocity: 28,
      gravity: 0.9,
      scalar: 0.8,
      ticks: 140,
      origin: { y: 0.55 },
      colors: ["#0ea5e9", "#00A3FF", "#38bdf8", "#7dd3fc", "#0B6BB0"],
      zIndex: 10000,
      disableForReducedMotion: true,
    });
  } catch {
    /* celebration must never break the flow */
  }
}
